import { apiClient } from '@/infrastructure/api/api-client';
import { exampleProducts } from '@/data/example-products';

export interface PublicProductSummary {
  id: string;
  slug: string;
  name: string;
  description: string;
  sizes: string[];
  price: string | null;
  status: string;
  mainPhoto: { url: string; altText: string | null } | null;
}

export interface PublicProductDetail extends PublicProductSummary {
  detailNotes: string | null;
  photos: { url: string; altText: string | null; displayOrder: number }[];
}

export async function getPublicProducts(filters?: {
  status?: string;
  size?: string;
}): Promise<PublicProductSummary[]> {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.size) params.set('size', filters.size);

  const query = params.toString();
  const path = query ? `/products?${query}` : '/products';

  const result = await apiClient.get<{ products: PublicProductSummary[] }>(path);
  return result.products;
}

export async function getProductBySlug(
  slug: string,
): Promise<PublicProductDetail | null> {
  try {
    const result = await apiClient.get<{ product: PublicProductDetail }>(
      `/products/${encodeURIComponent(slug)}`,
    );
    return result.product;
  } catch {
    // Fallback to example data for local dev without API
    const match = exampleProducts.find((p) => p.slug === slug);
    if (!match) return null;
    return {
      ...match,
      detailNotes: null,
      photos: match.mainPhoto ? [{ url: match.mainPhoto.url, altText: match.mainPhoto.altText, displayOrder: 0 }] : [],
    };
  }
}
